import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from 'src/components/calendars/assets/calendars.module.scss';
import { FormError } from 'src/components/redux-form/FormError';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { DecoratedFormProps, InjectedFormProps, reduxForm, change } from 'redux-form';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { FieldDate } from 'src/components/redux-form/fields/FieldDate';
import { asyncPersistSeance } from 'src/store/actions/seance-actions';
import { ICase } from 'src/types/case';
import { FieldDropdown } from 'src/components/redux-form/fields/FieldDropdown';
import { Paginated } from 'src/services/api-handlers/pagination';
import { StoreState } from 'src/store/reducers';
import { connect } from 'react-redux';
import Loader from 'src/components/Loader';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import OrderEnum from 'src/enumerables/order-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import user from 'src/services/user-auth';
import UserRole from 'src/enumerables/user-role';
import { useCookies } from 'react-cookie';
import { changeToZeroMoment } from '../../../../../../../../../helpers/timeHelpers';
import { CaseApi } from '../../../../../../../../../services/end-points';
import { Button, Modal } from 'react-bootstrap';

export interface SeanceFormData {
    id?: string | number;
    occasion?: string | number;
    seanceDate: string;
    status?: number;
    startTimeOld: Date | undefined;
    endTimeOld: Date | undefined;
    caseDropDown: SelectObject;
    startTime: string;
    providerCalendar?: boolean;
    studentCalendar?: boolean;
    endTime: string;
    isWeekly: boolean;
    goals?: string;
    problem?: string;
    attendance?: string;
    plan?: string;
    isTelehealth?: boolean;
    providers?: any;
    provId?: any;
    canEditSession?: string;
    hasPaid?: boolean;
}
interface RouteParams {
    id: string;
}

interface SeanceFormProps extends RouteComponentProps<RouteParams> {
    setData: (obj: any) => void;
    dispatch?: (obj: any) => void;
    caseValues: SelectObject[];
    providerCalendar?: boolean;
    studentCalendar?: boolean;
    deleteAction?: () => void;
    submit?: any;
    changeFieldValue?: any;
    inProgress?: boolean;
    month?: { monthEnd: string; monthStart: string };
    cases: Paginated<ICase>;
    inProgressCases: boolean;
    caseCurrent: Partial<ICase> | null;
}

type InjectedProps = InjectedFormProps<SeanceFormData, SeanceFormProps>;
const validators: Validators<SeanceFormData> = {
    caseDropDown: [required({ message: 'Choose the Case' }), maxLength({ max: 255 })],
};

let SeanceForm: React.FunctionComponent<InjectedProps & SeanceFormProps> = ({
                                                                                handleSubmit,
                                                                                error,
                                                                                dirty,
                                                                                match: {
                                                                                    params: { id },
                                                                                },
                                                                                deleteAction,
                                                                                submitting,
                                                                                changeFieldValue,
                                                                                inProgress,
                                                                                dispatch,
                                                                                setData,
                                                                                submit,
                                                                                inProgressCases,
                                                                                cases,
                                                                                initialValues,
                                                                            }: InjectedProps & SeanceFormProps) => {
    const isNew = !initialValues || !initialValues.id;
    const isSupervisor = user.getSupervisor();
    const isProvider = !user.getRoles().includes(UserRole.ROLE_ADMIN) && !isSupervisor;
    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);
    const isNotAllowChangeDate = !isAdmin && initialValues?.hasPaid;
    const caseValues: SelectObject[] = [];

    const [dataSaveModal, setSaveModal] = useState(false);

    const [existData, setExistData] = useState<any>(0);
    const [valueOrderTypeLabel, setValueOrderTypeLabel] = useState<string>('');
    const [isWeeklyClicked, setIsWeeklyClicked] = useState(false);

    const [isEnableCreate, setIsEnableCreate] = useState(true);

    const handleClick = (handleSubmit: (e: any) => void, e: any, isWeekly: boolean) => {
        if (existData?.length) {
            setSaveModal(true);
            if (isWeekly) {
                setIsWeeklyClicked(true);
            } else {
                setIsWeeklyClicked(false);
            }
        } else {
            if (isWeekly) {
                handleSub(handleSubmit, e);
            } else {
                handleSubNoWeekly(handleSubmit, e);
            }
        }
    };

    const handleSubExist = (handleSubmit: (e: any) => void, e: any) => {
        setSaveModal(false);
        if (isWeeklyClicked) {
            handleSub(handleSubmit, e);
        } else {
            handleSubNoWeekly(handleSubmit, e);
        }
    };

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        dispatch && dispatch(change('event-form', 'isWeekly', true));
        setTimeout(() => {
            handleSubmit(e);
        }, 1000);
    };
    const handleSubNoWeekly = (handleSubmit: (e: any) => void, e: any) => {
        if (!isNew) {
            dispatch && dispatch(change('event-form', 'isWeekly', false));
        }
        setTimeout(() => {
            handleSubmit(e);
        }, 1000);
    };
    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);
    cases.list.forEach((cas: Partial<ICase>) => {
        let name = '';
        let caseNumber = '';
        if (cas.caseType === 1) {
            caseNumber = cas.caseNumber ? cas.caseNumber + ',' : '';
        }
        if (cas.caseType === 3) {
            name = cas.district ? `${cas.district.name}` : 'unknown';
        } else if (cas.caseType === 4) {
            name = cas.vendor ? `${cas.vendor.name}` : 'unknown';
        } else {
            name = cas.student ? `${cas.student.firstName} ${cas.student.lastName}` : 'unknown';
        }

        let serviceType = cas?.serviceType?.title;
        if (!serviceType) {
            serviceType = cas?.serviceType?.cpt;
        }
        const serLocation = cas.occasionServiceLocations;
        if (serLocation && serLocation.length) {
            serLocation.sort((a: any, b: any) => {
                return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
            });
        }
        const serviceLocation =
            serLocation && serLocation.length && serLocation[serLocation.length - 1]?.serviceLocation
                ? `, ${serLocation[serLocation.length - 1].serviceLocation?.title}`
                : '';
        const orderTypeLabel: SelectObject | undefined | string = orderTypes.find((it) => it.value === cas.orderType);
        const orderTypeText = orderTypeLabel ? `${orderTypeLabel.label},` : '';
        const expiredAt = cas.caseNumberValidityTo
            ? 'Expires: ' + `${changeToZeroMoment(cas.caseNumberValidityTo, 'MMM D, YYYY')}` + ';'
            : '';
        const remaining = cas.orderEntity
            ? ' Remaining Hours: ' + `${cas.orderEntity?.amountOfRemainingHours}` + ';'
            : '';
        const expRem = ' (' + expiredAt + remaining + ')';
        const titleCase = `${name} (${orderTypeText} ${caseNumber} ${serviceType}${serviceLocation}  ) ${expRem}`;
        caseValues.push({ value: `${cas.id}`, label: titleCase });
    });
    caseValues.sort((a: any, b: any) => {
        return a.label.localeCompare(b.label);
    });
    changeFieldValue('student', { id });

    useEffect(() => {
        if (existData?.length) {
            const valueOrderType = orderTypes.find((it) => it.value === existData[0].orderType);
            setValueOrderTypeLabel(valueOrderType ? valueOrderType.label : '');
        }
        // eslint-disable-next-line
    }, [existData]);

    //Case is required
    const today = new Date();
    const disabled: boolean =
        (!!isProvider && !!initialValues.status && !!(+initialValues.status === 4)) || !!isNotAllowChangeDate;

    const [cookies, setCookie] = useCookies(['stCalProviderIDs']);
    let provIds = '';
    cookies.stCalProviderIDs?.forEach((prov: any) => {
        if (prov && prov.value) {
            provIds = provIds + ',' + prov?.value;
        }
    });
    const providers = provIds;
    changeFieldValue('providers', providers);

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <div style={dataSaveModal ? { display: 'none' } : {}}>
                <FormError error={error} />
                {inProgressCases ? <Loader noFull={true} /> : null}
                <FieldInput
                    name="id"
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name="student"
                    type="hidden"
                    value={id}
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name="providers"
                    type="hidden"
                    value={providers}
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />

                <FieldDropdown
                    name="caseDropDown"
                    data={caseValues}
                    disabled={!isNew || disabled}
                    placeholder={'Choose the case'}
                    textField={'label'}
                    valueField={'value'}
                    validate={validators.caseDropDown}
                    onChange={(data: any, pr) => {
                        setIsEnableCreate(false);
                        if (data?.value) {
                            const result = CaseApi.getCase(data?.value).then(async (response) => {
                                if (
                                    response?.data &&
                                    response?.data?.caseType == 1 &&
                                    (response?.data?.orderType == 2 || response?.data?.orderType == 3)
                                ) {
                                    const result = CaseApi.getCases({
                                        'orderEntity.caseNumber': response?.data?.caseNumber,
                                        caseType: 1,
                                        onlyActive: 1,
                                        orderType: [1, 6],
                                        'student.id': response?.data?.student?.id,
                                        page: 1,
                                        itemsPerPage: 1,
                                        pagination: 1,
                                    }).then(async (response2) => {
                                        //show the modal
                                        setExistData(response2?.data?.length ? response2?.data : 0);
                                        setIsEnableCreate(true);
                                    });
                                } else {
                                    setIsEnableCreate(true);
                                    setExistData(0);
                                }
                            });
                        }
                    }}
                    wrapperConfig={{
                        label: 'Case:',
                    }}
                />

                <FieldDate
                    name="seanceDate"
                    type="text"
                    disabled={disabled}
                    date={true}
                    className="mr-5"
                    wrapperConfig={{
                        label: 'Session Date:',
                    }}
                />
                <FieldDate
                    name="startTime"
                    type="text"
                    time={true}
                    disabled={disabled}
                    min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                    max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                    step={15}
                    formatType={'LT'}
                    className="mr-5"
                    wrapperConfig={{
                        label: 'Start Time:',
                    }}
                />
                <FieldDate
                    name="endTime"
                    type="text"
                    time={true}
                    formatType={'LT'}
                    disabled={disabled}
                    min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                    max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                    step={15}
                    className="mr-5"
                    wrapperConfig={{
                        label: 'End Time:',
                    }}
                />
            </div>
            {isNew ? (
                <div style={dataSaveModal ? { display: 'none' } : {}}>
                    <FieldInput
                        name="isWeekly"
                        type="checkbox"
                        disabled={disabled}
                        wrapperConfig={{
                            label: 'Weekly',
                            classes: {
                                inputWrapper: 'customCheckbox',
                            },
                        }}
                    />
                </div>
            ) : null}

            {initialValues.canEditSession === '1' || isNew ? (
                <div
                    className={classNames(styles.actions, 'justify-content-center text-center d-flex')}
                    style={dataSaveModal ? { visibility: 'hidden' } : {}}
                >
                    {isProvider && initialValues.status && +initialValues.status === 4 ? null : (
                        <button
                            type="button"
                            onClick={(event) => handleClick(handleSubmit, event, false)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            disabled={!dirty || submitting || !isEnableCreate}
                        >
                            <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                        </button>
                    )}
                    {!isNew &&
                    initialValues.status &&
                    initialValues.isWeekly &&
                    [1, 3].includes(initialValues.status) ? (
                        <button
                            type="button"
                            onClick={(event) => handleClick(handleSubmit, event, true)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            disabled={!dirty || submitting || !isEnableCreate}
                        >
                            <FontAwesomeIcon icon={faSave} /> Update Weekly
                        </button>
                    ) : null}
                    {!isNew ? (
                        isProvider && initialValues.status && +initialValues.status === 4 ? null : (
                            <Link
                                target="_blank"
                                className={classNames(styles.btnLink, 'btn', 'btn-outline-info', 'mr-3')}
                                to={Router.generate(routes.PROVIDER_DETAIL, {
                                    subId: initialValues.id,
                                    id: initialValues.provId,
                                    tab: 'case-sessions-edit',
                                })}
                            >
                                <FontAwesomeIcon icon={faStickyNote} /> <span>Note</span>
                            </Link>
                        )
                    ) : null}
                    {isNew ? (
                        <button
                            type="button"
                            className={classNames('btn', 'btn-danger')}
                            onClick={() => setData({ open: false, RenderData: <div></div> })}
                        >
                            <FontAwesomeIcon icon={faBan} /> Cancel
                        </button>
                    ) : (
                        !disabled && (
                            <button
                                type="button"
                                className={classNames('btn', 'btn-secondary')}
                                onClick={() => {
                                    deleteAction && deleteAction();
                                }}
                            >
                                <FontAwesomeIcon icon={faBan} /> Cancel
                            </button>
                        )
                    )}
                </div>
            ) : (
                <div></div>
            )}
            <div>
                {existData?.length ? (
                    <Modal
                        show={dataSaveModal}
                        onHide={() => {
                            setSaveModal(false);
                        }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            You have active {valueOrderTypeLabel} case for case number {existData[0].caseNumber}. Are
                            you sure you want to continue scheduling this session with the selected case?{' '}
                        </Modal.Body>
                        <Modal.Footer>
                            <form onSubmit={handleSubmit}>
                                <Button
                                    className={'mr-2'}
                                    variant="secondary"
                                    onClick={() => {
                                        setSaveModal(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <button
                                    type="submit"
                                    onClick={(event) => handleSubExist(handleSubmit, event)}
                                    className={classNames('btn', 'btn-success', 'mr-3')}
                                >
                                    <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                                </button>
                            </form>
                        </Modal.Footer>
                    </Modal>
                ) : null}
            </div>
        </form>
    );
};

function mapStateToProps(state: StoreState, ownProps: any): any {
    return {
        cases: state.cases.data,
        inProgressCases: state.cases.inProgress,
        inProgress: state.seances.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: any): any {
    return {
        changeFieldValue: function (field: any, value: any) {
            dispatch(change('event-form', field, value));
        },
    };
}

SeanceForm = connect(mapStateToProps, mapDispatchToProps)(withRouter(SeanceForm));
export default reduxForm<SeanceFormData, SeanceFormProps>({
    form: 'event-form',
    enableReinitialize: true,
    onSubmit: async (data: SeanceFormData, dispatch: Dispatch<any>, props: any) => {
        await asyncPersistSeance(
            {
                ...data,
                occasion: data?.caseDropDown ? `${data?.caseDropDown.value}` : '',
                studentCalendar: true,
                month: props.month,
            },
            {},
            dispatch,
        );
    },
    onSubmitSuccess(result: any, dispatch: Dispatch<any>, props: DecoratedFormProps<SeanceFormData, SeanceFormProps>) {
        const isNew = !props.initialValues || !props.initialValues.id;
        props.setData({
            open: false,
            RenderData: <div></div>,
        });
        toast.success(`Session was successfully ${isNew ? 'created' : 'updated'}.`);
    },
    onSubmitFail(errors: { _error: string }) {
        console.log('errors', errors);
        if (errors?._error) {
            toast.error(errors._error);
        }
    },
})(SeanceForm);
